var React = require('react');

function IconSmArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M9.922 6L8.59 7.332l4.327 4.336L8.59 16l1.332 1.332 5.668-5.668z","transform":"translate(-8.59 -6)"}));
}

IconSmArrowRight.defaultProps = {"width":"7","height":"12","viewBox":"0 0 7 12"};

module.exports = IconSmArrowRight;

IconSmArrowRight.default = IconSmArrowRight;
